export const explanations = [ 
  {
    description:  `In the test explanations you will use the two triangular buttons above to go backwards and forwards.
    In the test you will give your answers with the four round buttons: There are four possibilities: down, right, up and left.
    Generally, the examination consists of five tests. Work fast and accurate.`
  },
  {
    description:  '1st Test: Responsiveness Task: Arrow appears centrally and always points down. Always react with the "down" button as soon as it appears.'
  },
  {
    description:  '1'
  },
  {
    description:  '2nd Test: Concentration Task: One arrow appears on the screen edge and one in the center of the screen. React with the "down" button if at least one arrow points down.'
  },
  {
    description:  '2'
  },
  {
    description:  '3rd Test: Attentiveness Task: An arrow appears in the center of the screen and a cross appears at the edge of the screen. First react to the direction in which the arrow points, then react to the position of the cross. Here you would first press the "up" button and then the "down" button.'
  },
  {
    description:  '3'
  },
  {
    description:  '4th Test: Orientation Task: Search an array for a cross that has two lighter sections on the bottom. Press the "down" button if you detect it. Otherwise press the "right" button.'
  },
  {
    description:  '4'
  },
  {
    description:  '5th Test: Resilience Task: An arrow appears at the edge of the screen. Only press the "down" button, if the arrow points down.'
  },
  {
    description:  '5'
  }
];
